import React from "react";
import PropTypes from "prop-types";
import Header from "./Header";
import Footer from "./Footer";
import CookiePolicyBar from "./CookiePolicyBar";
import { FontLoader } from "design-react-kit";

import { useEffect } from "react";

export function useFixSwiperStyleId() {
  useEffect(() => {
    const fix = () => {
      const nodes = document.querySelectorAll(
        "head style#swiper-element-styles",
      );
      nodes.forEach((n) => {
        n.removeAttribute("id");
      });
    };
    fix();
    const head = document.head;
    if (!head) return;
    const obs = new MutationObserver((mutations) => {
      for (const m of mutations) {
        for (const node of m.addedNodes) {
          if (
            node.nodeType === 1 &&
            node.tagName === "STYLE" &&
            node.id === "swiper-element-styles"
          ) {
            fix();
            return;
          }
        }
      }
    });
    obs.observe(head, { childList: true });
    return () => obs.disconnect();
  }, []);
}

const Layout = ({ children, ...props }) => {
  useFixSwiperStyleId();
  return (
    <>
      <FontLoader />
      <Header sticky />
      <main>{children}</main>
      <Footer />
      <CookiePolicyBar />
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
